<template>
  <span>
    <div class="text-xs-center" v-if="commitmentDialog">
      <v-dialog v-model="commitmentDialog" @keydown.enter="commitmentConfirm" @keydown.esc="commitmentClose" persistent max-width="550" scrollable>
        <v-card>
        <v-card-title
        >
        Você deseja fazer um agendamento ou remarcar o compromisso?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" flat color="primary" @click.native="commitmentConfirm">{{'Remarcar Compromisso'}}</v-btn>
          <v-btn class="mx-0" flat @click.native="commitmentCancel">{{'Fazer um Agendamento'}}</v-btn>
          <v-btn class="mx-0" flat @click.native="commitmentClose">{{'Cancelar'}}</v-btn>
        </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- Dialog para filtrar eventos da agenda -->
    <v-dialog persistent v-model="eventFilter" scrollable max-width="700">
      <v-card>
        <v-card-title primary-title class="dialog-warning-title"> Filtrar eventos </v-card-title>
        <v-card-text justify-center>
          <v-radio-group v-model="eventFilterOptions.eventFilterType" row>
            <v-radio color="primary" label="Pessoal" value="personal"></v-radio>
            <v-radio :disabled="teams.length === 0" color="primary" label="Equipes" value="teams"></v-radio>
          </v-radio-group>
          <v-autocomplete v-if="eventFilterOptions.eventFilterType === 'personal'" v-model="eventFilterOptions.personal.legendTypePersonal" :items="legendOptionsPersonal" item-text="id_text" item-value="id" label="Legenda" chips></v-autocomplete>
          <!-- TEAMS -->
          <div v-if="eventFilterOptions.eventFilterType === 'teams'">
            <v-autocomplete v-model="eventFilterOptions.teams.selected" :items="teams" item-text="id_text" item-value="id" label="Equipes" :loading="users_loading" multiple chips @blur="changeTeams" @click="getTeams()">
              <template v-slot:prepend-item>
                <v-list-tile ripple @click="toggleSelected('teams')">
                  <v-list-tile-action>
                    <v-icon :color="eventFilterOptions.teams.selected.length > 0 ? 'indigo darken-4' : ''"> {{ icon }} </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Todas as equipes</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>

            <v-autocomplete v-model="eventFilterOptions.teams.userSelected" :items="users" item-text="id_text" item-value="id" label="Usuários" :loading="users_loading" :disabled="users_loading" multiple chips @blur="changeUsers">
              <template v-slot:prepend-item>
                <v-list-tile ripple @click="toggleSelected('users')">
                  <v-list-tile-action>
                    <v-icon :color="eventFilterOptions.teams.userSelected.length > 0 ? 'indigo darken-4' : ''"> {{ icon_team_all_users }} </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Todos os Usuários</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>
            <!-- Legenda -->
            <v-autocomplete v-model="eventFilterOptions.teams.legendTypeTeams" :items="legendOptionsTeams" item-text="id_text" item-value="id" label="Legenda" chips></v-autocomplete>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" flat color="primary" @click.native="filterEventFilter">FILTRAR</v-btn>
          <v-btn class="mx-0" flat @click.native="closeEventFilter">VOLTAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog para filtrar eventos da agenda -->

    <!-- Dialog para avisar ao usuário que ele não tem permissão para realizar certa ação -->
    <v-dialog v-model="dialog.show" @keydown.enter="dialog.show = false" persistent max-width="400" scrollable>
      <v-card>
        <v-card-title primary-title class="dialog-warning-title"> ATENÇÃO </v-card-title>
        <v-card-text justify-center>
          <h4 class="text-md-center">{{dialog.text}}</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" flat color="primary" @click.native="dialog.show = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog para avisar ao usuário que ele não tem permissão para realizar certa ação -->
    
    <div class="calendar-content" :style="`height:${windowSize - 120}px !important`">
      <div class="calendar-main">
        <v-layout wrap align-left id="legendFilter">
          <v-flex grow>
            <div class="filter">
              <v-tooltip bottom>
                <v-btn slot="activator" color="primary" @click="openEventFilter()"> {{ eventFilterOptions.eventFilterType === 'personal' ? 'Pessoal' : 'Equipes' }} </v-btn>
                <span v-if="eventFilterOptions.eventFilterType === 'personal'"> {{ this.$auth.user().id_text }} </span>
                <span v-else> {{ tooltipTeams }} </span>
              </v-tooltip>
              <span v-if="showMoreLegends">
                <v-btn small id="showChipLegend" text-color="primary" color="green" outline round @click="openMoreLegends = !openMoreLegends">
                  <span>Mostrar legendas...</span>
                </v-btn>
                <v-tooltip :attach="'#showChipLegend'" bottom v-model="openMoreLegends" min-width=300>
                  <v-card min-width=300>
                    <v-flex xs12>
                      <v-tooltip bottom>
                        <v-btn flat icon align-end color="#000" slot="activator">
                          <v-icon>close</v-icon>
                        </v-btn>
                        <span>Fechar</span>
                      </v-tooltip>
                    </v-flex>
                    <span v-for='item in legend' :key="item.id" style="text-align: center">
                      <v-avatar :color="item.color" size="20"></v-avatar>
                      <span> {{ item.id_text }} </span>
                    </span>
                  </v-card>
                </v-tooltip>
              </span>
              <span v-else v-for='item in legend' :key="item.id" style="text-align: center">
                <v-avatar :color="item.color" size="20"></v-avatar>
                <span> {{ item.id_text }} </span>
              </span>
            </div>
          </v-flex>
          <!-- <v-layout xs1 class="text-xs-right"> -->
          <v-flex shrink>
            <v-switch :label="'Mostrar Atividades'" v-if="viewType !== 'dayGridMonth' && $vuetify.breakpoint.smAndUp" v-model="showAllDay" @change="toggleAllDay"></v-switch>
          </v-flex>
          <v-flex shrink v-if="!$vuetify.breakpoint.smAndDown">
            <v-tooltip left>
              <v-btn outline fab small color="primary" slot="activator" :style="`margin-right: ${(isFullScreen || !tasksVisible) ? '50px' : '0px'};box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);`">
                <v-icon @click="toggleFullScreen(null)" medium>{{this.isFullScreen ? 'zoom_out' : 'zoom_in'}}</v-icon>
              </v-btn>
              <span v-if="isFullScreen">Reduzir fonte</span>
              <span v-else>Aumentar fonte</span>
            </v-tooltip>
          </v-flex>
          <!-- </v-layout> -->
        </v-layout>
        <FullCalendar
          ref="fullCalendar"
          class="full-calendar"
          :allDaySlot="false"
          :options='calendarOptions'
        />
      </div>

      <div class="toggle-button" v-show="!$vuetify.breakpoint.smAndDown">
        <v-tooltip v-if="this.tasksVisible" left>
          <v-btn flat icon align-end color="#000" @click="toggleTasksVisible" slot="activator">
            <v-icon>close</v-icon>
          </v-btn>
          <span>Ocultar Tarefas</span>
        </v-tooltip>
        <v-tooltip v-else left>
            <v-btn @click="toggleTasksVisible" outline fab small color="primary" slot="activator" :style="`box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);`">
              <v-icon medium>list</v-icon>
            </v-btn>
          <span>Exibir Tarefas</span>
        </v-tooltip>
      </div>

      <div :class="tasksVisible ? 'show-tasks' : 'hide-tasks'" v-show="!$vuetify.breakpoint.smAndDown">
        <div class="task-title" id="task-title">
          <div class="text-filter">
            <h1>Tarefas em Aberto</h1>
            <p-filter
              ref="filter"
              :allItems="tasks"
              :entity="'calendar_task'"
              :filterTypes="filterTypes"
              @afterChangeUserFilter="(res)=>{customFilterProcess(res)}">
            </p-filter>
          </div>
          <v-text-field @keyup.native="keyupSearch" class="text-search" append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
        </div>
        <!-- foi posto o v-show pois é feito processamento do draggable com o id dragTasks -->
        <p-task-list ref="list" motherEntity="calendar" :style="`height:${windowSize - 270}px !important`" :dontShowSubtasks="true" :select="25"
        :taskLoader="taskLoader" :hideOptions="true" idTaskMother="" :allTasks="tasks" :showCircleInfo="false"
        @reloadTasks="val => {getTaskItems()}"
        @changeTaskList="val => tasks = val"
        :totalTasks="tasksLength" mouseCursorItem="grab"
        :isMobileDesign="true" @clickMoreTask="clickMoreTask">
        </p-task-list>
      </div>
    </div>
    
    <v-dialog persistent scrollable v-model="modal_insert" max-width="700px">
      <calendar-insert :hasSwitch="viewType" @close="close" @pushEvent="pushEvent" ref="calendar_insert"></calendar-insert>
    </v-dialog>
    <v-layout justify-start align-start>
      <v-icon style="margin-top: 2px;" size=15>book</v-icon><span>Agendamento </span>&nbsp;&nbsp;
      <v-icon style="margin-top: 2px;" size=15>lens</v-icon><span>Atividade </span>&nbsp;&nbsp;
      <v-icon style="margin-top: 2px;" size=15>calendar_today</v-icon><span>Compromisso </span>
    </v-layout>
  </span>
</template>

<style scoped>
  .dialog-warning-title {
    background-color: #cccccc;
    font-size: 16px;
    font-weight: bold;
  }

  .calendar-content{
    display: flex;
    font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
    font-size: 14px;
  }

  .calendar-main{
    flex-grow: 1;
  }

  .calendar-full{
    font-size: 1.5em !important;
  }

  .calendar-content .toggle-button{
    position: absolute;
    right: 0;
    top: 0;
  }

  .hide-tasks{
    display: none;
  }

  .show-tasks{
    display: flex;
    flex-direction: column;
    margin-left: 6px;
    width: 300px;
    border: 1px solid #00acc2;
    border-radius: 5px 5px 0 0;
    padding: 0;
  }
  
  .text-search{
    padding: 12px 6px 0 6px;
  }

  .show-tasks .task-title{
    display: flex;
    flex-direction: column;
  }

  .show-tasks .task-title .text-filter{
    display: flex;
    flex-direction: column;
    align-items: left;
    padding-left: 6px !important;
  }

  .show-tasks .tasks-content{
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding-right: 2px;
  }
</style>

<script>
/* eslint-disable eqeqeq */
import access from './../../mixin/access'
import general from './../../mixin/general'
import PFilter from './../shared/PFilter'
import TaskEditable from './../shared/PTaskEditable'
import PTaskList from './../shared/PTaskList'
import CalendarInsert from './../shared/PCalendarInsert'
import momentDurationFormatSetup from 'moment-duration-format'
import moment from 'moment'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin, { Draggable } from '@fullcalendar/interaction'

momentDurationFormatSetup(moment)
export default {
  name: 'PCalendar',
  mixins: [access, general],
  components: {
    FullCalendar,
    CalendarInsert,
    TaskEditable,
    PTaskList,
    PFilter
  },
  data () {
    return {
      current_day: moment().startOf('week'),
      begin: '',
      end: '',
      // dragging = variavel criado para não dar erro ao incluir valores no this.calendarOptions.events.
      windowSize: window.innerHeight || document.body.clientHeight,
      dragging: false,
      modal_insert: false,
      // para criar o loader nas tarefas enquanto elas carregam
      taskLoader: false,
      setKeyup: null,
      tasksLength: 0,
      taskFilters: [],
      filter: [],
      viewStart: '',
      viewEnd: '',
      customRender: true,
      viewType: null,
      intervalConsultCalendar: null,
      taskRequest: false,
      showMoreLegends: false,
      openMoreLegends: false,
      commitmentDialog: false,
      isFullScreen: false,
      qtdMoreTasks: 1,
      dialog: {
        show: false,
        text: ''
      },
      entity: 'calendar',
      teams: [],
      users: [],
      categories: [],
      allTasks: [],
      tasks: [],
      eventFilter: false,
      legendOptionsPersonal: [
        { id: 0, id_text: 'Sem legenda' },
        { id: 1, id_text: 'Categorias' }
      ],
      legendOptionsTeams: [
        { id: 0, id_text: 'Sem legenda' },
        { id: 1, id_text: 'Categorias' },
        { id: 2, id_text: 'Usuário' }
      ],
      users_loading: true,
      beforeEventFilterOptions: {},
      eventFilterOptions: {
        eventFilterType: '',
        personal: {
          selected: [],
          legendTypePersonal: ''
        },
        teams: {
          selected: [],
          userSelected: [],
          legendTypeTeams: ''
        }
      },
      colors: ['#1E88E5', '#00838F', '#0D47A1', '#004D40', '#43A047', '#82B1FF', '#00ACC1', '#84FFFF', '#558B2F', '#0091EA', '#2962FF', '#1B5E20', '#01579B', '#00B8D4', '#00C853'],
      usersColor: [],
      legend: [],
      basePath: process.env.API,
      search: '',
      tasksVisible: false,
      showAllDay: true,
      calendarOptions: {
        initialView: 'timeGridWeek',
        eventContent: this.eventRender,
        headerToolbar: {
          left: 'prev,next,today',
          center: `${this.$vuetify.breakpoint.smAndDown ? '' : 'title'}`,
          right: 'timeGridDay,timeGridWeek,dayGridMonth,timeGridFourDay'
        },
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin // needed for dateClick
        ],
        windowResize: this.windowResize,
        longPressDelay: 200,
        views: {
          timeGridFourDay: {
            allDaySlot: true,
            type: 'timeGrid',
            duration: { days: 3 },
            buttonText: '3 dias'
          },
          timeGridWeek: {
            allDaySlot: true
          },
          timeGridDay: {
            allDaySlot: true
          },
          dayGridMonth: {
            allDaySlot: true
          }
        },
        allDaySlot: false,
        eventRender: this.eventRender,
        buttonText: { today: 'Hoje', month: 'Mês', week: 'Semana', day: 'Dia' },
        allDayText: 'Atividades',
        dayMaxEventRows: 3,
        slotDuration: '00:30',
        events: [],
        selectable: true,
        navLinks: true,
        tempEventEl: {},
        editable: true,
        droppable: true,
        nowIndicator: true,
        locale: 'pt-br',
        select: this.eventCreated,
        viewClassNames: this.viewClassNames,
        eventResize: this.eventResize,
        eventResizeStart: this.eventResizeStart,
        eventClick: this.eventClick,
        eventDrop: this.eventDrop,
        eventDragStart: this.eventDragStart,
        eventReceive: this.commitmentCheck
      }
    }
  },
  created () {
    this.$socket.emit('joinRoom', {room: `calendar${this.$auth.user().id}`})
    this.$store.commit('loader/change_dialog', true)
    let userFilter = this.$store.getters[`filter/values`]
    if (userFilter['calendar'] && userFilter['calendar']['view']) {
      this.viewType = userFilter['calendar']['view']
      this.calendarOptions.initialView = this.viewType
      var initialDate = userFilter['calendar']['initialDate'] ? userFilter['calendar']['initialDate'] : null
      var timestamp = Date.parse(initialDate)
      if (isNaN(timestamp) == false) {
        this.calendarOptions.initialDate = initialDate
      }
    } else this.viewType = 'timeGridWeek'
  },
  mounted () {
    if (this.$vuetify.breakpoint.smAndDown) this.calendarOptions.allDayText = 'Atv.'
    // Por usar o a função checkPermission, é colocado no mounted que já tera todos os valores necessários pra função
    this.calendarOptions.editable = this.checkPermission(this.entity, 'edit')
    this.calendarOptions.droppable = this.checkPermission(this.entity, 'edit')
    // regula o tamanho do calendário
    this.calendarOptions.height = this.windowSize - 200
    this.getTeams()
    this.viewStart = this.$refs.fullCalendar.getApi().view.currentStart
    this.viewEnd = this.$refs.fullCalendar.getApi().view.currentEnd
    this.viewStart = moment(this.viewStart).format('YYYY-MM-DD HH:mm')
    this.viewEnd = moment(this.viewEnd).format('YYYY-MM-DD HH:mm')
    if (!this.$vuetify.breakpoint.smAndDown) {
      // Busca os dados para o filtro das tarefas
      this.$http.get(`api/get_task_filters`).then(res => {
        this.taskFilters = res.body
        this.taskFilters['taskStatus'] = this.taskFilters['taskStatus'].filter(val => {
          return val.identifier != 3
        })
        this.redoFilter(null, false)
      })
    }
    //* Verificamos se há algum filtro no banco de dados. Se não houver, configuramos o filtro padrão:
    //* Pessoal: todos os eventos da pessoa (coringa 0) e sem legenda
    //* Equipes: todas as equipes (coringa -1) e sem legenda
    //* Tipo de filtro padrão: Pessoal - Sem legenda
    let filters = this.$store.getters[`filter/values`]
    if (!filters.hasOwnProperty(this.entity) || (filters.hasOwnProperty(this.entity) && !filters[this.entity]['eventFilterType'])) {
      this.eventFilterOptions.eventFilterType = 'personal'
      this.eventFilterOptions.personal.selected.push(0)
      this.eventFilterOptions.personal.legendTypePersonal = 0
      this.eventFilterOptions.teams.selected.push(-1)
      this.eventFilterOptions.teams.userSelected.push(-1)
      this.eventFilterOptions.teams.legendTypeTeams = 0
    } else {
      Object.assign(this.eventFilterOptions, filters[this.entity])
      // como o userSelected foi adicionado depois alguns usuários não possuem ele, portanto caso não tenha adiciona -1
      this.eventFilterOptions.teams.userSelected = filters[this.entity]['teams']['userSelected'] ? filters[this.entity]['teams']['userSelected'] : [-1]
    }
    this.changeTeams()
    this.consultCalendar()
    this.intervalConsultCalendar = setInterval(() => {
      // quando estava arratando e carregava os registros dava um erro duplicando os registros, o dragging foi ccriado para saber quando está arrastando
      if (!this.dragging) {
        this.consultCalendar(true)
      }
    }, 15000)
    if (!this.checkPermission(this.entity, 'edit')) {
      this.$store.commit('snackbar/change_values', {
        text: 'Você não tem permissão para editar agendamentos!',
        color: 'warning',
        timeout: 8000,
        dialog: true
      })
      return false
    } else {
      this.setupDraggableTasks()
    }
    this.toggleFullScreen(document.fullscreenElement === true)
    this.filter = JSON.parse(JSON.stringify(this.$refs.filter.filter))
  },
  sockets: {
    // Edita o evento no calendário
    editSocketCalendar (item) {
      var event = this.calendarOptions.events.find((val) => { return val.id === item.id })
      if (event) {
        Object.assign(event, JSON.parse(JSON.stringify(item)))
        this.addLegendColors()
      }
    },
    // Adiciona novo evento ao calendário
    addSocketCalendar (item) {
      this.prepareEventFromTask(item)
      if (this.eventFilterOptions.teams.selected.includes(item.task.team_id) || (item.user_id === this.$auth.user().id && this.eventFilterOptions.personal.selected.includes(0))) {
        this.calendarOptions.events.push(JSON.parse(JSON.stringify(item)))
        this.addLegendColors()
      }
    },
    deleteSocketCalendar (item) {
      const eventIndex = this.calendarOptions.events.findIndex((element) => { return element.id === item.id })
      this.calendarOptions.events.splice(eventIndex, 1)
    },
    //* Os três próximos eventos são para a manipulação em tempo real das tarefas na lateral do calendário
    editSocketCalendarTask (item) {
      let task = this.tasks.find((task) => { return task.id === item.id })
      Object.assign(task, JSON.parse(JSON.stringify(item)))
      this.redoFilter()
    },
    addSocketCalendarTask (item) {
      this.getTaskItems()
      this.redoFilter()
    },
    deleteSocketCalendarTask (item) {
      this.getTaskItems()
      this.redoFilter()
    }
  },
  methods: {
    changeTeams () {
      this.users_loading = true
      let teamsSelected = this.eventFilterOptions.teams.selected
      // Muda o time do filtro
      if (!teamsSelected || teamsSelected == -1) {
        teamsSelected = ''
      }
      let params = `type=${2}&teams=${teamsSelected}`
      this.$http.get(`api/get_users_by_hierarchy?${params}`).then(res => {
        this.users = res.body.sort((a, b) => { return a.id_text - b.id_text })
        this.users_loading = false
      })
    },
    getTeams () {
      this.users_loading = true
      // busca as equipes do usuário
      this.$http.get(`api/consult_calendar_info/${this.$auth.user().company_id}`).then((res) => {
        this.users_loading = false
        this.teams = res.body.teams.sort((a, b) => { return a.id_text - b.id_text })
      })
    },
    // Busca todos os dados das lista de tarefas e seus complementos
    clickMoreTask (qtd) {
      this.qtdMoreTasks = qtd
      this.getTaskItems()
    },
    commitmentCheck (val) {
      if (val.event.extendedProps.commitment === 1 && this.viewType !== 'dayGridMonth' && !val.event.allDay) {
        this.tempEventEl = val
        this.commitmentDialog = true
      } else {
        this.eventReceive(val)
      }
    },
    toggleAllDay (val) {
      this.calendarOptions.views[this.viewType].allDaySlot = val
    },
    commitmentCancel () {
      this.eventReceive(this.tempEventEl)
      this.commitmentDialog = false
    },
    keyupSearch () {
      // caso o usuario fique 1 segundo sem digitar e feita uma busca da pagina novamente
      clearTimeout(this.setKeyup)
      this.setKeyup = setTimeout(() => {
        this.getTaskItems()
      }, 1000)
    },
    commitmentClose () {
      this.tempEventEl.event.remove()
      this.commitmentDialog = false
    },
    commitmentConfirm () {
      this.$store.commit('loader/change_dialog', true)
      this.calendarOptions.events = this.calendarOptions.events.filter(event => { return !(event.isTask === 1 && event.task_id === this.tempEventEl.event.extendedProps.task_id) })
      let eventData = {
        all_day: this.tempEventEl.event.allDay,
        isTask: 1,
        begin: moment(this.tempEventEl.event.start).format(this.tempEventEl.event.allDay ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm'),
        end: this.tempEventEl.event.allDay ? moment(this.tempEventEl.event.start).add(1, 'd').format('YYYY-MM-DD 00:00') : moment(this.tempEventEl.event.start).add(1, 'h').format('YYYY-MM-DD HH:mm'),
        task_id: this.tempEventEl.event.extendedProps.task_id
      }
      let task = eventData.allDay ? {id: event.task_id, commitment: 0, begin: null, end: eventData.end} : {id: eventData.task_id, commitment: 1, begin: eventData.begin, end: eventData.end}
      this.$http.put('api/tasks/' + task.id, task).then(res => {
        let legendType = this.eventFilterOptions.eventFilterType === 'teams' ? this.eventFilterOptions.teams.legendTypeTeams : this.eventFilterOptions.personal.legendTypePersonal
        console.log(legendType)
        // if (legendType === 1) {
        //   this.tempEventEl.event.setProp('backgroundColor', res.body.category ? res.body.category.color : '#888888')
        //   this.tempEventEl.event.setProp('borderColor', res.body.category ? res.body.category.color : '#888888')
        // }
        let taskev = {
          id: -res.body.id,
          company_id: res.body.company_id,
          task_id: res.body.id,
          user_id: res.body.user_id,
          task: res.body,
          id_text: res.body.user ? res.body.user.id_text : 'Sem Responsável',
          user: res.body.user,
          company_id_text: res.body.company.id_text,
          company: res.body.company,
          title: res.body.identifier + ' - ' + res.body.id_text,
          start: res.body.begin,
          end: res.body.end,
          category_id: res.body['category'] ? res.body['category']['id'] : null,
          isTask: 1,
          isCommitment: res.body.commitment,
          category_id_text: res.body['category'] ? res.body['category']['id_text'] : '',
          color: res.body.category ? res.body.category.color : '#888888',
          allDay: res.body.commitment === 0
        }
        this.tempEventEl.event.remove()
        this.pushEvent(taskev)
      }, err => {
        alert('Erro! Falha ao enviar a requisição.')
        this.afterUpdateTask()
        console.log(err)
      }).finally(() => {
        this.$store.commit('loader/change_dialog', false)
        // this.consultCalendar()
        this.getTaskItems()
      })
      this.commitmentDialog = false
    },
    getTaskItems (loading = true) {
      if (loading) this.taskLoader = true
      this.taskRequest = true
      let params = {
        userOnly: true,
        page: 1,
        search: this.search,
        perPage: (this.qtdMoreTasks * 25) + 1,
        origin: 'calendar_task',
        filter: this.filter ? this.filter : {}
      }
      this.$http.post(`api/get_filtered_tasks`, params).then(res => {
        this.tasks = res.body['data']
        this.tasksLength = res.body['total']
        if (loading) this.taskLoader = false
      }, err => {
        console.log(err)
        this.$store.commit('snackbar/change_values', {text: 'Falha ao carregar tarefas do calendário', color: 'error', dialog: true})
      })
    },
    eventRender (arg, createElement, c) {
      let event = this.calendarOptions.events.find((ev) => { return arg.event.id == ev.id })
      let obj = {html: ''}
      let isMobile = this.$vuetify.breakpoint.smAndDown
      let isFinalized = false
      // commitment começa com 2 pois é o caso de ser o book de icone, ou seja agendamento
      let commitment = 2
      if (this.viewType === 'dayGridMonth') {
        // caso seja mensal e caso ele venha pelo drag
        if (arg.event.extendedProps && arg.event.extendedProps.commitment) {
          commitment = arg.event.extendedProps.commitment
        } else if (event && event.isTask === 1) {
          // caso ele venha do back
          isFinalized = event.status_identifier == 3
          commitment = event.isCommitment
        } else if (event && event.task.status) {
          isFinalized = event.task.status.identifier == 3
        }
        obj.html = `<div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" class="fc-daygrid-dot-event">${isMobile ? '' : `<i aria-hidden="true" class="v-icon material-icons theme--light" style="padding-top 2px !important; font-size: 15px; color: ${arg.backgroundColor}; caret-color: ${arg.backgroundColor};">${commitment === 1 ? 'calendar_today' : (commitment === 2 ? 'book' : 'lens')}</i><div class="fc-event-time" style="color: #00acc1 !important;">${arg.timeText.length === 2 ? arg.timeText + ':00' : arg.timeText}</div>`}<div style="word-break: break-word; color: #6e6e70; ${isFinalized ? 'text-decoration: line-through;' : ''}"  class="fc-event-title fc-sticky">${arg.event.title}</div></div>`
        arg.backgroundColor = '#ffffff'
        return obj
      } else if (event && event.isTask === 1) {
        // caso n venha pelo mensal e venha do back
        isFinalized = event.status_identifier == 3
        commitment = event.isCommitment
      } else if (arg.event.extendedProps && arg.event.extendedProps.commitment) {
        // caso n venha do mensal e venha pelo drag
        commitment = arg.event.extendedProps.commitment
      } else if (event && event.task.status) {
        isFinalized = event.task.status.identifier == 3
      }
      obj = {html: '<div class="fc-event-main"><div class="fc-event-main-frame">'}
      // se a diferença entre o begin e o end for igual a 1.800.000 quer dizer que a duração é meia hora e o timetext n deve exibir
      if (!isMobile) obj.html = obj.html + `<div style="font-size: 10px !important;" ><i class="v-icon material-icons" style="position: relative; top: 2px; font-size: 13px;">${commitment === 1 ? 'calendar_today' : (commitment === 2 ? 'book' : 'lens')}</i>&nbsp;<span style="${isFinalized ? 'text-decoration: line-through;' : ''}">${arg.event.end - arg.event.start === 1800000 ? '' : arg.timeText}</span></div>`
      obj.html = obj.html + `<div class="fc-event-title-container"><div style="word-break: break-all; ${isFinalized ? 'text-decoration: line-through;' : ''}" class="fc-event-title fc-sticky">` + arg.event.title + '</div></div>'
      obj.html = obj.html + `</div></div>`
      return obj
    },
    // Método para fazer a configuração dos elementos que poderão ser arrastados para gerar eventos no calendário (as tarefas na lateral do calendário)
    setupDraggableTasks () {
      var self = this
      let divTasks = document.getElementById('dragTasks')
      /* eslint-disable-next-line */
      new Draggable(divTasks, {
        itemSelector: '.dg-task',
        eventData: function (e) {
          self.dragging = true
          let textEl = e.getElementsByClassName('text')
          let taskIdEl = e.getElementsByClassName('task-id')
          let commitment = e.getElementsByClassName('commitment')
          let teamIdEl = e.getElementsByClassName('team-id')
          let elText = textEl[0].innerText
          elText = elText.replace(' - ', '-')
          let event = {
            color: '#4b9ccb',
            id_text: self.$auth.user().id_text,
            user_id: self.$auth.user().id,
            task_id: parseInt(taskIdEl[0].innerText),
            commitment: parseInt(commitment[0].innerText),
            team_id: parseInt(teamIdEl[0].innerText),
            title: elText
          }
          return event
        }
      })
    },
    toggleFullScreen (openFullScreen) {
      openFullScreen = ((openFullScreen === null) ? !this.isFullScreen : openFullScreen)
      var element = document.getElementsByClassName('full-calendar')[0]
      // Coloca a dashboard em modo FULLSCREEN quando selecionado o botão de visualização
      // Cada uma das linhas é necessária pois existem diferentes formas de se maximizar e algumas não funcionam em determinados navegadores, e diferentes formas também considerando o estado atual da tela a ser maximizada
      if (openFullScreen) {
        this.isFullScreen = true
        element.classList.add('calendar-full')
        this.tasksVisible = false
        this.calendarOptions.slotDuration = '00:20'
        this.calendarOptions.allDaySlot = false
        this.calendarOptions.headerToolbar = false
      } else {
        this.isFullScreen = false
        element.classList.remove('calendar-full')
        this.calendarOptions.slotDuration = '00:30'
        this.calendarOptions.allDaySlot = true
        this.calendarOptions.headerToolbar = {left: `${this.$vuetify.breakpoint.smAndDown ? 'prev,next' : 'prev,next,today'}`, center: `${this.$vuetify.breakpoint.smAndDown ? '' : 'title'}`, right: 'timeGridDay,timeGridWeek,dayGridMonth,timeGridFourDay'}
      }
    },
    identifierSequence (task) {
      let fatherTask = task.tree_task_sequence
      if (fatherTask) {
        return this.identifierSequence(fatherTask) + '.' + task.identifier
      } else {
        return task.identifier
      }
    },
    // Cria a estrutura quando vem de uma tarefa normal, exemplo, colocando a sequencia do identifier, ou o company_id
    prepareEventFromTask (task) {
      task.identifier = this.identifierSequence(task)
      return task
    },
    changeUsers () {
      // Tirar o -1(todos os itens) quando tiver sido selecionado outros itens
      if (this.eventFilterOptions.teams.userSelected.length > 1 && this.eventFilterOptions.teams.userSelected[0] === -1) {
        this.eventFilterOptions.teams.userSelected.shift()
      }
    },
    toggleSelected (type) {
      this.$nextTick(() => {
        if (type === 'teams') {
          this.eventFilterOptions.teams.selected = (this.eventFilterOptions.teams.selected.length === 1 && this.eventFilterOptions.teams.selected.includes(-1)) ? [] : [-1]
        } else if (type === 'users') {
          this.eventFilterOptions.teams.userSelected = (this.eventFilterOptions.teams.userSelected.length === 1 && this.eventFilterOptions.teams.userSelected.includes(-1)) ? [] : [-1]
        }
      })
    },
    windowResize (arg) {
      this.windowSize = window.innerHeight || document.body.clientHeight
      // Caso não esteja com o botão para mostrar todas as legendar verifica qual o tamanho no momento, para ver se vai diminuir.
      let legendFilter = document.getElementById('legendFilter')
      if (!this.showMoreLegends && legendFilter) {
        this.showMoreLegends = legendFilter.offsetHeight > 100
      }
      this.calendarOptions.height = this.windowSize - (200)
      this.calendarOptions.headerToolbar = {left: `${this.$vuetify.breakpoint.smAndDown ? 'prev,next' : 'prev,next,today'}`, center: `${this.$vuetify.breakpoint.smAndDown ? '' : 'title'}`, right: 'timeGridDay,timeGridWeek,dayGridMonth,timeGridFourDay'}
    },
    openEventFilter () {
      this.dragging = true
      this.eventFilter = !this.eventFilter
      this.beforeEventFilterOptions = JSON.parse(JSON.stringify(this.eventFilterOptions))
      if (this.teams.length === 0) {
        this.$store.commit('snackbar/change_values', {text: 'Você precisa ser responsável de pelo menos uma equipe para habilitar a opção "Equipes"!', color: 'info', dialog: true, timeout: 6000})
      }
    },
    closeEventFilter () {
      this.dragging = false
      this.eventFilter = false
      this.eventFilterOptions = JSON.parse(JSON.stringify(this.beforeEventFilterOptions))
    },
    filterEventFilter () {
      this.legend = []
      this.usersColor = []
      this.dragging = false
      this.eventFilter = false
      this.showMoreLegends = false
      this.consultCalendar(false, true)
    },
    // realTime significa que será atualizado tempo em tempo. E possui um processo um pouco diferente
    consultCalendar (realTime = false, fromFilter = false) {
      //! IMPORTANTE
      //! Utilizamos alguns "coringas" passados como id's para as consultas de eventos no banco de dados. Eles são:
      //! 0  => PESSOAL - utilizado para buscar somente os eventos da pessoa. É utilizado quando o usuário seleciona o filtro "pessoal".
      //! -1 => TODAS AS EQUIPES - utilizado para buscar eventos de todas as equipes em que o usuário é responsável. É utilizado quando o usuário seleciona o filtro de equipes mas não seleciona nenhuma equipe no campo "select"
      // Pega o primeiro dia do mes e subtrai 7 dias pois no calendario filtrado por mes, aparece no maximo 7 dias do mes passado
      let calendarStart = {}
      if (this.$refs.fullCalendar) calendarStart = this.$refs.fullCalendar.getApi().view.currentStart
      let startOfMonth = moment(calendarStart).startOf('month').subtract(7, 'days').format('YYYY-MM-DD 00:00')
      // Pega o último dia do mes e adiciona 15 dias pois no calendario filtrado por mes, aparece no maximo 15 dias do mes seguinte
      let endOfMonth = moment(calendarStart).endOf('month').add(15, 'days').format('YYYY-MM-DD 23:59')
      if (this.eventFilterOptions.eventFilterType === 'personal') {
        this.eventFilterOptions.personal.selected = [0]
      } else {
        // se estiver selecionado o filtro de equipes e não for selecionado nenhuma equipe, passamos -1 como parametro para a consulta para buscar todas as equipes em que o usuário é responsável
        if (this.eventFilterOptions.teams.selected.length === 0) {
          this.eventFilterOptions.teams.selected = [-1]
        } else if (this.eventFilterOptions.teams.selected.length > 1 && this.eventFilterOptions.teams.selected.includes(-1)) {
          // caso seja selecionada alguma equipe, verificamos se o array de selecionados possui o "id coringa" -1. Se tiver, devemos removê-lo do array
          let index = this.eventFilterOptions.teams.selected.findIndex((el) => { return el === -1 })
          this.eventFilterOptions.teams.selected.splice(index, 1)
        }
      }
      if (!realTime) this.$store.commit('loader/change_dialog', true)
      this.$http.get(`api/consult_calendar`, {params: {'startOfMonth': startOfMonth, 'endOfMonth': endOfMonth, 'typeFilter': (this.eventFilterOptions.eventFilterType === 'teams' ? this.eventFilterOptions.teams.selected : this.eventFilterOptions.personal.selected), 'typeFilterUser': this.eventFilterOptions.teams.userSelected, 'order': (this.eventFilterOptions.eventFilterType === 'teams' ? this.eventFilterOptions.teams.legendTypeTeams : this.eventFilterOptions.personal.legendTypePersonal)}}).then(res => {
        // Caso já tenha sido feito a requisição se estiver em um momento de arrastar, não deve continuar o processo
        if (!this.dragging) {
          this.calendarOptions.events = res.body
          this.addLegendColors()
          if (!realTime) {
            this.changeUserFilter()
            this.$store.commit('loader/change_dialog', false)
          }
          // Quando vem do fuiltro tem que prepreencher a equipe do filtro de tarefas
          if (fromFilter) {
            // Atualiza a lista de tarefas para apenas as equipes filtradas
            // let right: 'timeGridDay,timeGridWeek,dayGridMonth,timeGridFourDay'
            if (this.eventFilterOptions.eventFilterType === 'teams') {
              if (this.eventFilterOptions.teams.selected.includes(-1)) {
                let selectedAllTeams = []
                this.teams.map((team) => {
                  selectedAllTeams.push(team.id)
                })
                this.redoFilter(null, {team_id: selectedAllTeams, user_id: this.eventFilterOptions.teams.userSelected, end_end: this.viewEnd, end_begin: this.viewStart, end_period: 'Período', begin_period: ''})
              } else {
                this.redoFilter(null, {team_id: this.eventFilterOptions.teams.selected, user_id: this.eventFilterOptions.teams.userSelected, end_end: this.viewEnd, end_begin: this.viewStart, end_period: 'Período', begin_period: ''})
              }
            } else {
              this.redoFilter(null, {team_id: '', user_id: [`${this.$auth.user().id}-${this.$auth.user().company_id}`], end_end: this.viewEnd, end_begin: this.viewStart, end_period: 'Período', begin_period: ''})
            }
            this.eventFilter = false
          }
          // this.eventFilterType = (this.selected.length === 1 && this.selected[0] === 0) ? 'personal' : 'teams'
          // chama função para adicionar eventos aos botões do calendário
          this.setOnClickEvents()
        }
      })
    },
    // Este método adiciona os eventos "onclick" aos botões de "prev" e "next" neste momento porque fazíamos este processo no "created" e, ao executar a consulta no banco de dados, o componente de calendário recarregava e perdíamos esse vinculo. Então alteramos para adicionar os eventos "onclick" novamente toda vez que fizermos a consulta.
    setOnClickEvents () {
      let _this = this
      setTimeout(function () {
        var previous = document.getElementsByClassName('fc-prev-button')[0]
        var next = document.getElementsByClassName('fc-next-button')[0]
        var today = document.getElementsByClassName('fc-today-button')[0]
        next.onclick = function () { _this.next() }
        previous.onclick = function () { _this.next() }
        // verifica se existe o today pois no mobile ele não existe
        if (today) today.onclick = function () { _this.next() }
      }, 100)
    },
    addLegendColors () {
      let legendType = this.eventFilterOptions.eventFilterType === 'teams' ? this.eventFilterOptions.teams.legendTypeTeams : this.eventFilterOptions.personal.legendTypePersonal
      switch (legendType) {
        //* Sem legenda - cor padrão para todos os eventos
        case 0: {
          this.legend = []
          this.calendarOptions.events.forEach((e) => {
            e.color = '#4b9ccb'
          })
          this.legend.push({ id: -1, color: '#4b9ccb', id_text: 'Sem legenda' })
          break
        }
        case 1: {
          //* Legenda por categorias - cores por categorias das tarefas
          this.calendarOptions.events.forEach((e) => {
            let task = {}
            task = e
            if (!task.category_id) {
              e.color = '#4b9ccb'
              e.category_id_text = 'Sem categoria'
              task.category_id = 0
            } else {
              // Para as categorias sem cor inclui a cor '#888888'
              e.color = task.color ? task.color : '#888888'
            }
            //* Verificando se já existe registro daquela categoria no array das legendas
            if (!this.legend.some((el) => { return el.id === task.category_id })) {
              this.legend.push({ id: task.category_id, color: e.color, id_text: e.category_id_text })
            }
          })
          break
        }
        case 2: {
          //* Legenda por usuário - cor para cada usuário
          this.calendarOptions.events.forEach((e) => {
            let userColor = this.usersColor.find((val) => { return val.user_id === e.user_id && val.company_id === e.company_id })
            if (userColor) {
              e.color = userColor.color
            } else {
              // Verificamos se o index é maior ou igual a 14 (limite do array de cores) para que ao acabar a quantidade de cores, voltar ao início do array e assim passará a repetir as cores.
              e.color = this.colors[this.usersColor.length % 14]
              this.usersColor.push({user_id: e.user_id, company_id: e.company_id, color: e.color})
              //* Insere o registro na legenda
              this.legend.push({ id: (e.user_id + '_' + e.company_id), color: e.color, id_text: e.id_text + (e.company_id !== this.$auth.user().company_id ? ' (' + e.company_id_text + ')' : '') })
            }
          })
          break
        }
      }
      if (!this.showMoreLegends) {
        setTimeout(() => {
          let legendFilter = document.getElementById('legendFilter')
          if (legendFilter) this.showMoreLegends = legendFilter.offsetHeight > 100
        }, 300)
      }
    },
    next () {
      // Pega o primeiro dia do mes filtrado no caledario
      this.viewStart = this.$refs.fullCalendar.getApi().view.currentStart
      this.viewEnd = this.$refs.fullCalendar.getApi().view.currentEnd
      this.viewStart = moment(this.viewStart).format('YYYY-MM-DD HH:mm')
      this.viewEnd = moment(this.viewEnd).format('YYYY-MM-DD HH:mm')
      this.redoFilter(null, {end_end: this.viewEnd, end_begin: this.viewStart, end_period: 'Período', begin_period: ''})
      let calendarStart = this.$refs.fullCalendar.getApi().view.currentStart
      // Verifica se o mês do primeiro dia antes de mudar é diferente do mês do primeiro dia atual
      if (moment(this.current_day).format('MM') !== moment(calendarStart).format('MM')) {
        this.$store.commit('loader/change_dialog', true)
        this.consultCalendar()
      }
      this.current_day = calendarStart
      // Muda o filtro para salvar no banco alguma alteração que o usuário tenha feito
      this.changeUserFilter()
    },
    eventClick (val) {
      if (!this.checkPermission('tasks', 'manage')) {
        this.$store.commit('snackbar/change_values', {
          text: 'Você não tem permissão para gerenciar tarefas!',
          color: 'warning',
          timeout: 5000,
          dialog: true
        })
        return false
      } else {
        this.$router.push(`/task/${val.event.extendedProps.task_id}?return=calendar`)
      }
    },
    eventDragStart (val) {
      this.dragging = true
    },
    eventDrop (val) {
      this.$store.commit('loader/change_dialog', true)
      // Quando o usuário arrasta o campo do evento(arrasta o quadrado do evento no caledário)
      let event = this.calendarOptions.events.find((ev) => { return val.event.id == ev.id })
      // Atualiza os campos de inicio e fim do task_calendar
      let resize = {
        // begin: val.start.format(val.allDay ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm'),
        begin: moment(val.event.start).format(val.event.allDay ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm'),
        // Quando pegamos um quadro de evento e arratamos para o 'dia inteiro' ou tiramos do 'dia inteiro' o valor de end fica null, quando isso ocorre devemos setar o valor do begin + 1 dia se arrastado para o dia inteiro ou 1 hr se tirado do dia inteiro
        // end: (val.end !== null) ? val.end.format(val.allDay ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm') : moment(val.start).add(1, val.allDay ? 'days' : 'hours').format(val.allDay ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'),
        end: (val.event.end === null) ? moment(val.event.start).format(val.event.allDay ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm') : moment(val.event.end).format(val.event.allDay ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm'),
        all_day: val.event.allDay
      }
      if (event && event.isTask === 0) {
        this.$http.put(`api/task_calendar/${parseInt(val.event.id)}`, resize).then((res) => {
          let data = {id: res.body.id, start: res.body.begin, end: res.body.end, allDay: res.body.all_day}
          // Modifica o valor da variavel this.calendarOptions.events, pois ele não muda apenas visualmente
          let event = this.calendarOptions.events.find((value) => { return value.id === parseInt(val.event.id) })
          Object.assign(event, JSON.parse(JSON.stringify(data)))
          this.addLegendColors()
          // Edita o evento na tela de calendário
          for (let user in res.body.task.participants) {
            this.$socket.emit('generalEvent', {
              data: data,
              responseEvent: 'editSocketCalendar',
              room: `calendar${res.body.task.participants[user]}`
            })
          }
          // Edita o item no gerenciamento de tarefas
          // Data alterada pois as durações da agenda do gerenciamento de tarefas possui uma estrutura diferente
          data = {id: res.body.id, begin: res.body.begin, end: res.body.end, all_day: res.body.all_day}
          this.$socket.emit('generalDetailsEvent', {
            data: data,
            details: 'calendar',
            responseEvent: 'editSocketDetails',
            room: `tasks${res.body.task_id}_manage`
          })
          this.setOnClickEvents()
          this.dragging = false
          this.$store.commit('loader/change_dialog', false)
        },
        err => {
          alert('Erro! Falha ao enviar a requisição.')
          console.log(err)
        })
      } else {
        let task = resize.all_day ? {id: event.task_id, commitment: 0, begin: null, end: resize.end} : {id: event.task_id, commitment: 1, begin: resize.begin, end: resize.end}
        this.dragging = false
        this.$http.put('api/tasks/' + task.id, task).then(res => {
          console.log(res.body)
          // sockets
        }, err => {
          alert('Erro! Falha ao enviar a requisição.')
          console.log(err)
          this.afterUpdateTask()
        }).finally(() => {
          this.$store.commit('loader/change_dialog', false)
          this.consultCalendar(false, false)
          this.getTaskItems(false)
        })
      }
    },
    afterUpdateTask (resBody) {
      for (let prop in resBody.participants) {
        this.$socket.emit('generalEvent', {
          data: resBody,
          responseEvent: 'editSocketItem',
          room: `tasks${resBody.participants[prop]}`
        })
        this.$socket.emit('generalEvent', {
          data: resBody.status ? resBody.status.id_text : ['Sem Status'],
          notBroadcast: true,
          responseEvent: 'reloadStatusPageByName',
          room: `kanban${resBody.participants[prop]}`
        })
      }
    },
    eventReceive (val) {
      let eventData = {
        all_day: val.event.allDay,
        begin: moment(val.event.start).format(val.event.allDay ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm'),
        end: val.event.allDay ? moment(val.event.start).add(1, 'd').format('YYYY-MM-DD 00:00') : moment(val.event.start).add(1, 'h').format('YYYY-MM-DD HH:mm'),
        task_id: val.event.extendedProps.task_id
      }
      // Se a agenda for de equipe irá abrir o dialog para selecionar o responsavel do agendamentos se for pessoal ira apenas adicionar
      this.$store.commit('loader/change_dialog', true)
      this.$http.post('api/task_calendar', eventData).then((res) => {
        let event = {
          id: res.body.id,
          allDay: !!res.body.all_day,
          category_id_text: res.body.task.category_id ? res.body.task.category.id_text : null,
          color: res.body.task.category ? res.body.task.category.color : '#888888',
          category_id: res.body.task.category ? res.body.task.category.id : null,
          company_id: res.body.company.id,
          company_id_text: res.body.company.id_text,
          end: res.body.end,
          id_text: res.body.user.id_text,
          start: res.body.begin,
          task: res.body.task,
          task_id: res.body.task.id,
          title: val.event.title,
          user_id: res.body.user_id
        }
        // adiciona o evento ao vetor de eventos do calendário
        this.pushEvent(event)
        this.setOnClickEvents()
        this.$socket.emit('generalDetailsEvent', {
          data: event,
          responseEvent: 'addSocketDetails',
          details: 'calendar',
          room: `tasks${event.task_id}_manage`
        })
        this.dragging = false
        this.$store.commit('loader/change_dialog', false)
      },
      err => {
        console.log(err)
      })
      // Ao arrastar um evento externo para o calendário, é criado um quadrado no local para representar onde irá ficar o novo evento. Porém quando adicionamos o evento ao array this.calendarOptions.events, ele renderiza outro evento por cima deste e fica duplicado. Então utilizamos o método "val.event.remove()" (https://fullcalendar.io/docs/Event-remove) para remover ele do calendário e ficar somente o evento renderizado do array this.calendarOptions.events
      val.event.remove()
    },
    viewClassNames (change) {
      let start = this.$refs.fullCalendar.getApi().view.currentStart
      let end = this.$refs.fullCalendar.getApi().view.currentEnd
      start = moment(start).format('YYYY-MM-DD HH:mm')
      end = moment(end).format('YYYY-MM-DD HH:mm')
      if (start !== this.viewStart || end !== this.viewEnd) {
        this.calendarOptions.views[change.view.type].allDaySlot = this.showAllDay
        this.viewStart = start
        this.viewEnd = end
        this.viewType = change.view.type
        if (this.eventFilterOptions.eventFilterType === 'teams') {
          if (this.eventFilterOptions.teams.selected.includes(-1)) {
            let selectedAllTeams = []
            this.teams.map((team) => {
              selectedAllTeams.push(team.id)
            })
            this.redoFilter(null, {team_id: selectedAllTeams, user_id: '', end_end: this.viewEnd, end_begin: this.viewStart, end_period: 'Período', begin_period: ''})
          } else {
            this.redoFilter(null, {team_id: this.eventFilterOptions.teams.selected, user_id: '', end_end: this.viewEnd, end_begin: this.viewStart, end_period: 'Período', begin_period: ''})
          }
        } else {
          this.redoFilter(null, {team_id: '', user_id: [`${this.$auth.user().id}-${this.$auth.user().company_id}`], end_end: this.viewEnd, end_begin: this.viewStart, end_period: 'Período', begin_period: ''})
        }
      }
      // Muda o filtro para salvar no banco alguma alteração que o usuário tenha feito
      setTimeout(() => {
        this.changeUserFilter()
      }, 100)
    },
    eventResizeStart (val) {
      this.dragging = true
    },
    customFilterProcess (val) {
      this.filter = val
      this.getTaskItems()
    },
    eventResize (val) {
      // console.log('event-resize')
      this.$store.commit('loader/change_dialog', true)
      // Quando o usuário aumenta o campo do evento(expande o quadrado do evento no caledário)
      // Atualiza os campos de inicio e fim do task_calendar
      let event = this.calendarOptions.events.find((ev) => { return val.event.id == ev.id })
      let resize = {
        begin: moment(val.event.start).format(val.allDay ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm'),
        end: moment(val.event.end).format(val.allDay ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm'),
        all_day: val.allDay
      }
      if (event && event.isTask === 0) {
        this.$http.put(`api/task_calendar/${parseInt(val.event.id)}`, resize).then((res) => {
          let data = {id: res.body.id, start: res.body.begin, end: res.body.end, allDay: res.body.all_day}
          // Modifica o valor da variavel this.calendarOptions.events, pois ele não muda apenas visualmente
          Object.assign(event, JSON.parse(JSON.stringify(data)))
          // Edita o evento na tela de calendário
          for (let user in res.body.task.participants) {
            this.$socket.emit('generalEvent', {
              data: data,
              responseEvent: 'editSocketCalendar',
              room: `calendar${res.body.task.participants[user]}`
            })
          }
          // Edita o item no gerenciamento de tarefas
          // Data alterada pois as durações da agenda do gerenciamento de tarefas possui uma estrutura diferente
          data = {id: res.body.id, begin: res.body.begin, end: res.body.end, all_day: res.body.all_day}
          this.$socket.emit('generalDetailsEvent', {
            data: data,
            details: 'calendar',
            responseEvent: 'editSocketDetails',
            room: `tasks${res.body.task_id}_manage`
          })
          this.setOnClickEvents()
          this.dragging = false
          this.$store.commit('loader/change_dialog', false)
        },
        err => {
          alert('Erro! Falha ao enviar a requisição.')
          console.log(err)
        })
      } else {
        let task = resize.allDay ? {id: val.event.extendedProps.task_id, commitment: 0, begin: null, end: resize.end} : {id: val.event.extendedProps.task_id, commitment: 1, begin: resize.begin, end: resize.end}
        this.$http.put('api/tasks/' + task.id, task).then(res => {
          console.log(res.body)
          // sockets
        }, err => {
          alert('Erro! Falha ao enviar a requisição.')
          this.afterUpdateTask()
          console.log(err)
        }).finally(() => {
          this.$store.commit('loader/change_dialog', false)
        })
      }
    },
    eventCreated (val) {
      if (!this.checkPermission(this.entity, 'create')) {
        this.$store.commit('snackbar/change_values', {
          text: 'Você não tem permissão para inserir agendamentos!',
          color: 'warning',
          timeout: 5000,
          dialog: true
        })
        return false
      }
      if (!this.checkPermission('tasks', 'create')) {
        this.$store.commit('snackbar/change_values', {
          text: 'Você não tem permissão para inserir tarefas!',
          color: 'warning',
          timeout: 5000,
          dialog: true
        })
        return false
      }
      // console.log('event-created')
      this.dragging = true
      let values = {
        horary_calendar: {
          // begin: val.startStr.format(val.allDay ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm'),
          begin: moment(val.start).format(val.allDay ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm'),
          // end: val.endStr.format(val.allDay ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm'),
          end: val.allDay ? moment(val.end).subtract(1, 'days').format('YYYY-MM-DD 23:59') : moment(val.end).format('YYYY-MM-DD HH:mm'),
          all_day: val.allDay
        },
        filterType: this.eventFilterOptions.eventFilterType,
        teams: this.teams
      }
      this.modal_insert = true
      this.$refs.calendar_insert.calendarClick(values)
      this.setOnClickEvents()
    },
    pushEvent (val) {
      this.calendarOptions.events.push(val)
      this.addLegendColors()
      // Adiciona o evento na tela de calendário
      this.$socket.emit('generalEvent', {
        data: val,
        responseEvent: 'addSocketCalendar',
        room: `calendar${val.user_id}`
      })
      // Incluindo valores para incluir o item com os campos corretos na consulta de agenda do gerenciamento de tarefas
      val['begin'] = val.start
      val['all_day'] = val.allDay
      val['company_id'] = this.$auth.user().company_id
      val['company'] = val.company
      val['user'] = val.user
      // Adiciona o item no gerenciamento de tarefas
      this.$socket.emit('generalDetailsEvent', {
        data: val,
        details: 'calendar',
        responseEvent: 'addSocketDetails',
        room: `tasks${val.task.company_id}_${val.task_id}`
      })
      this.setOnClickEvents()
    },
    close () {
      this.modal_insert = false
      this.dragging = false
    },
    // Filter usado para passar alguns valores para já preencher no filter, como as equipes quando selecioando as equipes no calendario, as quaisa devem ser passadar para lista de tarefas
    redoFilter (values = null, filters = {}) {
      // Usado para executar o filtro padrão do usuário. Assim é carregado todos os valores para o filtro funcionar
      // É usado um get para buscar o user pois this.$auth.user() não busca o filtro do usuário atualizado
      let filterInterval = setInterval(() => {
        // setInterval para verificar quando termina de carregar o filtro do usuário
        if (this.$store.getters[`filter/loaded`]) {
          if (this.$refs.filter) {
            let userFilter = this.$store.getters[`filter/values`]
            this.$refs.filter.userFilter = userFilter || {}
            this.$refs.filter.filter = {}
            let taskFilter = Object.assign((userFilter['calendar_task'] || {}), filters)
            // verifica se existe o filtro
            if (taskFilter) {
              this.$refs.filter.filter = taskFilter
            }
            if (Object.keys(this.$refs.filter.filter).length > 0) {
              this.$refs.filter.customFilter(values)
            } else {
              // this.tasks = this.allTasks
            }
          }
          // Desabilita o loading
          this.$store.commit('loader/change_dialog', false)
          clearInterval(filterInterval)
        }
      }, 100)
    },
    changeUserFilter () {
      let userFilter = this.$store.getters[`filter/values`]
      let initialDate = this.$refs.fullCalendar.getApi().view.currentStart
      // verifica se o botão hj está marcado
      let isNow = document.getElementsByClassName('fc-today-button fc-button fc-button-primary')[0]
      // verifica se existe o isNow pois no mobile ele não existe
      if (isNow) isNow = isNow.disabled
      userFilter[this.entity] = {
        eventFilterType: this.eventFilterOptions.eventFilterType,
        personal: {
          selected: this.eventFilterOptions.personal.selected,
          legendTypePersonal: this.eventFilterOptions.personal.legendTypePersonal
        },
        teams: {
          selected: this.eventFilterOptions.teams.selected,
          userSelected: this.eventFilterOptions.teams.userSelected,
          legendTypeTeams: this.eventFilterOptions.teams.legendTypeTeams
        },
        view: this.viewType,
        initialDate: isNow ? null : moment(initialDate).format('YYYY-MM-DD')
      }
      this.$store.commit('filter/change_values', userFilter)
      this.$http.post('auth/change-filter', {'filter': JSON.stringify(userFilter[this.entity]), 'entity': this.entity}).then(() => {
        // this.$store.commit('loader/change_dialog', false)
      })
    },
    toggleTasksVisible () {
      this.tasksVisible = !this.tasksVisible
      window.dispatchEvent(new Event('resize'))
    }
  },
  destroyed () {
    clearInterval(this.intervalConsultCalendar)
    this.$socket.emit('leaveRoom', {room: `calendar${this.$auth.user().id}`})
  },
  computed: {
    filterTypes: function () {
      return [
        // {field: 'id_text', type: 'string'},
        {field: 'user_id', many_field: ['user_id', 'connection_company_id'], type: 'array', items: this.taskFilters['taskUsers'], text: 'id_text', not_close: true, value: 'id'},
        {field: 'client', second_field: 'id_text', label: 'Cliente', type: 'array', items: this.taskFilters['taskClients'], text: 'id_text', value: 'id'},
        {field: 'urgency', type: 'array', items: this.translate('value.task_urgency')},
        {field: 'category', second_field: 'id_text', label: 'Categoria', type: 'array', items: this.taskFilters['taskCategories'], text: 'id_text', value: 'value'},
        {field: 'status', second_field: 'id_text', label: 'Status', type: 'array', items: this.taskFilters['taskStatus'], text: 'id_text', value: 'value', optionAllLess: ['Finalizada']},
        {field: 'team_id', type: 'array', label: 'Equipe', items: this.taskFilters['taskTeams'], text: 'id_text', value: 'id', disabled: this.eventFilterOptions.eventFilterType === 'teams'},
        {field: 'begin', type: 'date'},
        {field: 'end', not_close: true, type: 'datetime'}
        // {field: 'note', type: 'string'}
      ]
    },
    tooltipTeams () {
      let names = ''
      if (this.eventFilterOptions.eventFilterType === 'teams' && this.eventFilterOptions.teams.selected[0] === -1) {
        names = 'Todas as equipes'
      } else {
        this.teams.forEach((team) => {
          if (this.eventFilterOptions.teams.selected.includes(team.id)) {
            names += `${team.id_text}, `
          }
        })
        names = names.substring(0, names.length - 2)
      }
      return names
    },
    icon () {
      return (this.eventFilterOptions.teams.selected.length === 1 && this.eventFilterOptions.teams.selected.includes(-1)) ? 'check_box' : 'check_box_outline_blank'
    },
    icon_team_all_users () {
      return (this.eventFilterOptions.teams.userSelected.length === 1 && this.eventFilterOptions.teams.userSelected.includes(-1)) ? 'check_box' : 'check_box_outline_blank'
    }
  }
}
</script>
<style>
  .fc-timegrid-axis-cushion {
    font-size: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PCalendar.vue